import * as React from "react";
import { useFontSwitcher } from "source/app/presentation/Shared/Fonts/Hooks/useFontSwitcher";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import {
    ANOPENSCROLL_FONT_FAMILY,
    DEFAULT_CLIENT_FONT_FAMILY,
} from "source/app/services/UI/Fonts/BodyFont";
import { ETexture } from "source/app/services/UI/Background/Texture/ETexture";
import { Texture } from "../../../../services/UI/Background/Texture/Texture";
import { FadeInText } from "../../Animation/FadeInArray";
import { GetNavigationMenuItems } from "../NavigationMenu/NavigationMenuItems";
import { ITitleProps } from "./ITitleProps";

export function Title({ id, withClass }: ITitleProps) {
    const useAnopenscrollFont = useFontSwitcher();
    const navMenuItem = GetNavigationMenuItems().find((item) => item.id === id);

    if (!navMenuItem) {
        throw new Error(`Cannot find nav menu item with id ${id}`);
    }

    const titleText = navMenuItem.title;

    const background = new Texture({
        image: ETexture.xv,
        backgroundColor: { h: 0, s: 1, l: 11, a: 0.25 },
    }).combinedCSS;

    return (
        <div
            className={withClass}
            {...Style(`activePanelTitle_${useAnopenscrollFont}`, {
                ...background,
                fontFamily: useAnopenscrollFont
                    ? ANOPENSCROLL_FONT_FAMILY
                    : DEFAULT_CLIENT_FONT_FAMILY,
            })}
        >
            <FadeInText text={titleText} />
        </div>
    );
}
